<template>
<form class="login-form wmin-sm-400" action="index.html">
    <div class="card mb-0">
        <div class="min-vh-100 active card-body fade show tab-pane">
            <login-component :sso="true" :redirect="this.$route.query.redirect"></login-component>
        </div>
    </div>
</form>
</template>

<script>
import LoginComponent from "./Login";
// import RegisterComponent from "./Register";
import VerifyComponent from "./Verify";

export default {
    components: {
        LoginComponent,
        // RegisterComponent,
        VerifyComponent,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/IndexLoginSSO.vue